import React from 'react';
import { Pagination } from 'react-admin';

// A large, not infinite, page size behind the "All" entry. react-admin sends the
// chosen size straight to the data provider, and a literal -1 upsets its page
// arithmetic (it derives totalPages from total / perPage), so "All" is a number
// big enough that every page's data fits on one. The provider passes it through
// as a limit that no realistic list reaches.
export const ALL_PER_PAGE = 100000;

export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100, 250, { label: 'All', value: ALL_PER_PAGE }];

const ListPagination = props => (
    <Pagination rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS} {...props} />
);

export default ListPagination;
